/**
 * メッセージ定数
 */
const messageDefine = {
  // タイトル表記
  title: {
    qrCode: ['海外在住証明QRコード 自動作成サービス'],
    info: '確認',
    error: 'エラー',
    issueInfo: '発行日の確認',
    livingDateInfo: '国外に住所を定めた日の確認',
  },
  // 本文表記: 配列で表現、配列要素は改行区切りで表示される
  body: {
    createQrCodeTop: ['一時帰国日本人の免税購入には海外在住確認（戸籍附票または海外在留証明書）が必要です。', '下記にご自身の情報を入力しQRコード作成ボタンを押下すると海外在住情報がQRコード化できます。', '書類原本と共に免税会計時にご提示下さい。免税手続の円滑化にご協力をお願い致します。'],
    downloadQrCodeTop: ['お客様のQRコードが完成しました。免税会計時に書類原本とあわせてご提示下さい。', '当該モバイルサイトには入力情報は記録保存されません。', '今後もQRコードを利用したい場合、保存ボタンを押下しお客様のスマホに画像保存下さい。'],
    caution: '上記に入力された情報は外部サーバー等に一切保存されません。QRコード作成時に消去されます。',
    landDateEmpty: ['直近の入国日（帰国日）を選択してください。'],
    typeEmpty: ['証明書の種類を選択してください。'],
    issueDateEmpty: ['発行日を選択してください。'],
    livingDateEmpty: ['国外に住所を定めた日を選択してください。'],
    domicileEmpty: ['本籍地を入力してください。'],
    sourceEmpty: ['発行元公館名を入力してください。'],
    numberEmpty: ['発行番号を入力してください。'],
    landDateAndIssueDate: ['証明書は直近入国日の6ヶ月前の日以後に発行されたものでなければいけません。'],
    issueDateAndLivingDate: ['当該日付は証明書が発行された時点よりも2年以前でなければなりません。'],
    futureIssueDate: ['発行日が未来日付になっています。発行日を確認してください。'],
    pastDate: ['当該日付は過去日付でなければなりません。'],
    downloadComplete: ['画像を保存しました。'],
    downloadError: ['画像の保存に失敗しました。'],
  },
};

export default messageDefine;
